import React, { useEffect, useState } from 'react'
import SideModal from '../SideModal/SideModal'
import { Form } from 'react-bootstrap'
import { AdminService } from '../../services/admin.service';
import toast from 'react-hot-toast';

const EditInstructorPricingModal = (props: any) => {
    const [instructorPricing, setInstructorPricing] = useState<any>(undefined);

    console.log(props);

    const fetchInstructorPrcing = async ()=>{
        await AdminService.getInstructorPricingFromEnrollment(props.show).then((res)=>{
            if(res.status==200){
                toast.success("Fetched Instructor Pricing");
                console.log(res.data); 
                if(res.data.instructorPricing.instructorPricing){
                    setInstructorPricing(res.data.instructorPricing.instructorPricing);
                }
            }
            else{
                toast.error("Unable to get instructor pricing");
            }
        });
    }

    const updateInstructorPricing = async ()=>{
        await AdminService.updateInstructorPricingFromEnrollment(props.show, {instructorPrice: instructorPricing}).then((res)=>{
            if(res.status==200){
                toast.success("Instructor Pricing updated");
                props.handleClose(undefined);
            }
            else{
                toast.error("Something went wrong");
            }
        });   
        fetchInstructorPrcing();
    }

    useEffect(()=>{
        if(props.show!=undefined){
            fetchInstructorPrcing();
        }
    },[props.show]);

    return (
        <SideModal
            show={props.show!=undefined ? true : false}
            handleClose={() => props.handleClose(undefined)}
            body={
                <>
                    <Form.Group>
                        <Form.Label>Set Instructor Pricing</Form.Label>
                        <Form.Control
                            value={instructorPricing}
                            type="number"
                            onChange={(e)=>{setInstructorPricing(e.target.value)}}
                        />
                    </Form.Group>
                    <div className="btn btn-primary btn-block mb-4 mt-4" onClick={() => updateInstructorPricing()}>
                        Update Changes
                    </div>
                </>
            }
            title="Edit Instructor Pricing"
        />
    )
}

export default EditInstructorPricingModal